import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { CardPaperSize, ReportPrintOptions } from "../../../../model/load-card-print-options";
import { Rodeo } from "../../../../model/rodeo";
import { RodeoEvent } from "../../../../model/rodeoEvent";
import { RodeoEventSchedule } from "../../../../model/rodeoEventSchedule";
import { ReportsService } from "../../../../services/reports.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { RodeoEventRun } from "../../../../model/rodeoEventRun";
import Sortable from 'sortablejs';
import { ToastController } from "ionic-angular";
import { RunService } from "../../../../services/run.service";
import { Subscription } from "rxjs";

@Component({
    selector: 'load-cards-report',
    templateUrl: 'report-load-cards.html'
})
export class LoadCardsReportComponent implements OnInit, AfterViewInit {
    @Input('rodeo') rodeo: Rodeo;
    @Input('options') options: FormGroup;
    @Output('loading') loading = new EventEmitter<boolean>();
    @ViewChild('sortableList') sortableList: ElementRef;

    runs: RodeoEventRun[] = [];
    loadOrderUpdated = false;

    penLabels = ['P1', 'P2', 'P3', 'P4'];
    maxLivestockPerPen = 10;

    private subscriptions: Subscription[] = [];

    constructor(
        private toast: ToastController,
        private runService: RunService,
        private changeDetRef: ChangeDetectorRef
    ) { }

    ngOnInit() {
    }     

    ngAfterViewInit() {
        new Sortable(this.sortableList.nativeElement, {
          animation: 0,
          onStart: () => {
            this.changeDetRef.detach();
          },
          onEnd: (e) => {
            this.loadOrderUpdated = true;
            this.reorderArray(e);
            this.changeDetRef.reattach();
          }
        });

        this.subscriptions.push(this.options.get('rodeoEventId').valueChanges.subscribe((newValue) => this.getRuns(this.options.value.scheduleName, newValue)));
        this.subscriptions.push(this.options.get('scheduleName').valueChanges.subscribe((newValue) => this.getRuns(newValue, this.options.value.rodeoEventId)));
    }

    trackByIndex(index: number, item: any): number {
        return index;
    }

    trackById(index: number, item: any) {
        return item.id;
    }

    async saveLoadOrder() {
        this.loading.emit(true);
        for(let i = 0; i < this.runs.length; i++) {
            const run = this.runs[i];
            run.loadOrder = i;
        }
        console.log(this.runs);
        try {
            await this.runService.updateLoadOrder(this.runs);
        } catch (err) {
            this.toast.create({
                message: 'Could not save load order.',
                duration: 2000
            }).present();
            return false;
        } finally {
            this.loading.emit(false);
        }

        this.loadOrderUpdated = false;

        return true;
    }

    private getRuns(scheduleName, rodeoEventId) {
        this.loadOrderUpdated = false;
        if (scheduleName && rodeoEventId > 0) {
            const rodeoEvent = this.rodeo.rodeoEvents.find(x => x.id == rodeoEventId);
            const schedule = rodeoEvent.schedules.find(x => x.name == scheduleName);
            this.runs = schedule.runs.find(x => x.loadOrder > 0) ? schedule.runs.sort((a,b) => a.loadOrder - b.loadOrder) : schedule.runs;
        } else {
            this.runs = [];
        }
    }

    private reorderArray(e: any) {
        const { oldIndex, newIndex } = e;

        if (oldIndex !== newIndex) {
            const movedItem = this.runs.splice(oldIndex, 1)[0];
            this.runs.splice(newIndex, 0, movedItem);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-load-cards.ts